import Modal1  from "./Pages/Modal1";
import "./App.css";

import MainRoutes from "./Pages/MainRoutes";
import Middle from "./Pages/Middle";

function App() {

  return (
    <div>
    <MainRoutes/>
    </div>
  );
}

export default App;
